import React from 'react'

export const Eggrafa = ({ pageItem }) => {
  return (
    <div><p className='enimerwseis-allages-title'>{pageItem.no}. {pageItem.eidos_org}</p>
      <p className='enimerwseis-allages-title'>{pageItem.perilipsi}</p></div>
  )
}
